export default __webpack_public_path__ + "static/media/i-speedometer_connect.9cf816ca.svg";